import { usePage } from "@inertiajs/vue3";
import { displayFlash, Status } from "@utils/displayFlash";
import { watch } from "vue";

export type FlashProps = {
  flash?: FlashMessage;
};

export function useFlash() {
  const flashTypes = [
    { key: "success", status: Status.Success },
    { key: "error", status: Status.Error },
    { key: "notice", status: Status.Notice },
  ];

  const page = usePage<PrintavoProps & FlashProps>();

  watch(
    () => page.props.flash,
    (flash) => {
      const flashType = flashTypes.find(({ key }) => flash?.[key]);

      if (flashType) {
        displayFlash(flashType.status, flash[flashType.key]);
      }
    },
    { deep: true, immediate: true },
  );
}
